/**
 * HITL-1756 — the most of one modifier an agent can ring on one item
 * ("coffee, 4 cream, 4 sugar"). A fixed cap for now: the brand menu carries no
 * per-option limit yet (VI-1507). When it does, `getModifierMaxQuantity` reads
 * it and this becomes the fallback.
 */
export const MAX_MODIFIER_QUANTITY = 9;
